import { BadgeColor, formatDate, getDateStatus } from '@urbanx/agx.ui-components2'

export interface DueDateBadgeState {
  text: string
  color: BadgeColor
  type: 'colourfill' | 'highlighted'
  highlightText?: string
}

export const getStatusBadgeColor = (
  inProgress: boolean,
  isPending: boolean
): BadgeColor => {
  if (isPending) return 'red'
  return inProgress ? 'blue' : 'green'
}

export const getDueDateBadgeState = (
  dueDate: string,
  isCompleted: boolean
): DueDateBadgeState => {
  const status = isCompleted ? 'Completed' : getDateStatus(dueDate ?? '')

  if (status === 'Invalid date') {
    return {
      type: 'colourfill',
      color: 'red',
      text: 'Invalid date',
    }
  }

  const date = `${formatDate(dueDate ?? '', false)}`
  const text = isCompleted ? date : `Due ${date}`
  const isHighlighted = isCompleted || ['Today', 'Overdue'].includes(status)
  const color = (status === 'Overdue' ? 'red' : 'yellow') as BadgeColor

  return isHighlighted
    ? {
        type: 'highlighted',
        color,
        text,
        highlightText: status,
      }
    : {
        type: 'colourfill',
        color,
        text,
      }
}
